export default __webpack_public_path__ + "static/media/esri-topo.37271096.png";